import type { FaireCategoryEntity } from "../../entity_types/category";

export const catalog_cat_crafts_hobbies: FaireCategoryEntity = {
  token: "catalog_cat_crafts-hobbies",
  type: "category",
  name: "Crafts & hobbies",
  count: 4,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
